/** The Talent Community's sections, grouped as in Anna's mockup v0.5. Each is its own URL under /talent-pool. */
export const SECTIONS = [
  {
    heading: null,
    items: [
      ['overview', 'Overview'],
      ['search', 'Talent Search'],
      ['campaigns', 'Campaigns'],
      ['dashboard', 'Dashboard'],
    ],
  },
  {
    heading: 'Candidate-facing',
    items: [
      ['portal', 'Portal Preview'],
      ['leads', 'Leads sign-up'],
    ],
  },
  { heading: 'Settings', items: [['templates', 'Templates'], ['import', 'Lever import']] },
] as const;

export type SectionId = (typeof SECTIONS)[number]['items'][number][0];


const ALL: readonly (readonly [SectionId, string])[] = SECTIONS.flatMap((g): readonly (readonly [SectionId, string])[] => g.items);

export const sectionLabel = (id: SectionId) => ALL.find(([s]) => s === id)?.[1] ?? 'Overview';

export const isSection = (t: string | undefined): t is SectionId => ALL.some(([id]) => id === t);
